'use client';
import PopupBody from '@molecules/PopupBody/PopupBody';
import { Popup } from 'devextreme-react';
import React from 'react';

export enum DIALOGUE {
  INFO,
  ALERT,
  ERROR,
  SUCCESS,
}

// function getBackgroundColor(variant: DIALOGUE) {
//   switch (variant) {
//     case DIALOGUE.ALERT:
//       return '#dcdc38';
//     case DIALOGUE.ERROR:
//       return cssVars.red;
//     case DIALOGUE.SUCCESS:
//       return '#4cff4c';
//     case DIALOGUE.INFO:
//     default:
//       return 'var(--primary-500)';
//   }
// }

interface AddDialogue {
  message: string | React.ReactNode;
  buttons?: Array<{ text: string | React.ReactNode; onClick: (close: () => void) => void }>;
  variant?: DIALOGUE;
}

interface Dialogue {
  id: number;
  message: string | React.ReactNode;
  buttons?: Array<{ text: string; onClick: () => void }>;
  variant: DIALOGUE;
}

const defaultApi = {
  dialogues: [] as Dialogue[],
  show: (dialogue: AddDialogue) => {
    /*default*/
  },
  clearDialogue: (id: number) => {
    /*default*/
  },
};

export type DialoguesContextValue = typeof defaultApi;

const DialoguesContext = React.createContext<DialoguesContextValue>(defaultApi);

/**
 * Custom Dialogues Provider
 */
function DialoguesProvider({ children }: any) {
  // Dialogues queue is managed in local useState
  const [dialogues, setDialogues] = React.useState<Dialogue[]>(defaultApi.dialogues);

  // Method to push a new dialogue
  const show = React.useCallback(
    (dialogue: AddDialogue) => {
      setDialogues((dialogues) => [
        ...dialogues,
        {
          id: new Date().getTime(), // we use UIDs in the final ver
          variant: DIALOGUE.ERROR,
          ...dialogue,
        } as Dialogue,
      ]);
    },
    [setDialogues],
  );

  // Method to clear a dialogue
  const clearDialogue = React.useCallback(
    (id: number) => {
      const nextDialogues = dialogues.filter((n) => n.id !== id);
      setDialogues(nextDialogues);
    },
    [dialogues, setDialogues],
  );

  // Return Provider with full API
  const api = { dialogues, show, clearDialogue };
  const currentDialogue = dialogues[dialogues.length - 1];
  const defaultButtonConfig = [{ text: 'OK', onClick: () => clearDialogue(currentDialogue.id) }];
  return (
    <DialoguesContext.Provider value={api}>
      {children}
      {currentDialogue && (
        // <Dialogue {...dialogues[dialogues.length - 1]} clearDialogue={clearDialogue} />
        <Popup onHiding={() => clearDialogue(currentDialogue.id)}>
          <PopupBody buttonConfig={currentDialogue.buttons ?? defaultButtonConfig}>{currentDialogue.message}</PopupBody>
        </Popup>
      )}
    </DialoguesContext.Provider>
  );
}

export function useDialogues() {
  return React.useContext(DialoguesContext);
}

export default DialoguesProvider;
